import { render, staticRenderFns } from "./FormModal.vue?vue&type=template&id=16edf74c&"
import script from "./FormModal.vue?vue&type=script&lang=ts&"
export * from "./FormModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16edf74c')) {
      api.createRecord('16edf74c', component.options)
    } else {
      api.reload('16edf74c', component.options)
    }
    module.hot.accept("./FormModal.vue?vue&type=template&id=16edf74c&", function () {
      api.rerender('16edf74c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserManagement/Menu/FormModal.vue"
export default component.exports